export function getXPForLevel(level) {
  return Math.floor(100 * Math.pow(1.1, level - 1)); // L1=100, L2=120, etc.
}

export function getXPProgress(totalXP) {
  let level = 0;
  let xpUsed = 0;
  let xpForNextLevel = getXPForLevel(level + 1);

  while (totalXP >= xpUsed + xpForNextLevel) {
    xpUsed += xpForNextLevel;
    level++;
    xpForNextLevel = getXPForLevel(level + 1);
  }

  const xpInLevel = totalXP - xpUsed;
  const progress = xpInLevel / xpForNextLevel;

  return {
    level: level , 
    xpInLevel,
    xpToNextLevel: xpForNextLevel,
    progress,
  };
}
